import { getIn, useFormikContext } from 'formik';
import { useMemo } from 'react';

import { type SegmentedControlProps } from '@hivebrite/design-system/SegmentedControl';
import { SegmentedControl } from '@hivebrite/design-system/SegmentedControl';

interface SegmentedControlInputProps
  extends Pick<SegmentedControlProps, 'controls'> {
  name: string;
}

export const SegmentedControlInput = ({
  name,
  controls = [],
}: SegmentedControlInputProps) => {
  const { values, setFieldValue } = useFormikContext();

  const value = getIn(values, name);

  const controlledControls = useMemo(
    () =>
      controls.map((control) => ({
        ...control,
        value: control.value,
        active: control.value === value,
      })),
    [controls, value],
  );

  return (
    <SegmentedControl
      controls={controlledControls}
      onChange={(control) => {
        setFieldValue(name, control.value);
      }}
    />
  );
};
